import { useAppSelector } from "./useAppStore";

export function useAuth() {
  const auth = useAppSelector((state) => state.auth);

  return {
    ...auth,
    isAuthenticated: !!auth.token,
    isAdmin:         auth.role === "bridge13_admin",
    isCourier:       auth.role === "bridge13_courier",
    isPartner:       auth.role === "partner",
  };
}
